import React from "react";
import "./headSection.css"
import MetaData from "../MetaData/MetaData";
import {MetaDataInfo} from "../MetaData/MetaDataInfo";
import PropTypes from "prop-types";

class HeadSection extends React.Component{

    render() {
        let {
            keyword,
        } = this.props;
        return (
           <>
               <MetaData keyword={keyword}/>
               <div className="head-section">
                   <h1 className="header-text head-section-main-header">
                       {MetaDataInfo[keyword].Header}
                   </h1>
                   {
                       MetaDataInfo[keyword].PageDescription !== undefined && MetaDataInfo[keyword].PageDescription !== null && MetaDataInfo[keyword].PageDescription !== ""?
                           <div className="header-section-description">
                               {MetaDataInfo[keyword].PageDescription}
                           </div>
                           :
                           null
                   }

               </div>
           </>
        );
    }


}


HeadSection.defaultProps = {
    keyword: "home",
}

HeadSection.propTypes = {
    keyword: PropTypes.oneOf(["home","solution","pricing","aboutUs"]).isRequired,

}

export default HeadSection;